export interface Tomo {
  emoji: string;
  num: string;
  title: string;
  desc: string;
}
export interface Bono {
  num: string;
  title: string;
  desc: string;
  value: string;
}
export interface Testimonial {
  initials: string;
  name: string;
  location: string;
  role: string;
  quote: string;
}
export interface Faq {
  q: string;
  a: string;
}
export const TOMOS: Tomo[] = [{
  emoji: '📘',
  num: 'Tomo 1',
  title: 'La Recepcionista Digital',
  desc: 'Bio, perfil, SEO local, destacadas y link de reserva. Tu perfil trabajando las 24 horas.'
}, {
  emoji: '📗',
  num: 'Tomo 2',
  title: 'Arquitectura Visual',
  desc: 'Imagen de marca, fotografía en gabinete, branding visual y feed premium.'
}, {
  emoji: '📙',
  num: 'Tomo 3',
  title: 'Ingeniería de Stories',
  desc: 'Conexión diaria, secuencias de stories, venta invisible y story-selling.'
}, {
  emoji: '📕',
  num: 'Tomo 4',
  title: 'Reels de Alto Valor',
  desc: 'Alcance, autoridad, videos educativos y posicionamiento local.'
}, {
  emoji: '📓',
  num: 'Tomo 5',
  title: 'El Cierre Maestro',
  desc: 'Ventas por DM, protocolo de respuesta, objeciones y cierre de turnos.'
}, {
  emoji: '📔',
  num: 'Tomo 6',
  title: 'El Calendario Pro',
  desc: 'Planificación mensual, 30 días de contenido y batching en una mañana.'
}];
export const TOMO_FEATURES: string[] = ['Estrategia completa lista para implementar', 'Ejemplos reales del rubro estética argentino', 'Scripts y textos listos para copiar y adaptar', 'Checklists de implementación por capítulo', 'Ejercicios prácticos con resultado inmediato', 'Tablas, plantillas y sistemas de gestión', 'Lenguaje argentino con casos locales reales', '100% orientado a convertir seguidores en turnos'];
export const BONOS: Bono[] = [{
  num: '01',
  title: 'El Calendario Pro',
  desc: '30 días de contenido planificados. Todo el mes listo en una mañana.',
  value: "$17.990"
}, {
  num: '02',
  title: '100 Hooks Estéticos',
  desc: 'Ganchos irresistibles para posts, reels y stories. Listos para usar.',
  value: "$17.990"
}, {
  num: '03',
  title: 'DM Cierre Pro',
  desc: 'Plantillas de respuesta para consultas, objeciones y cierre de turnos por WhatsApp.',
  value: "$17.990"
}, {
  num: '04',
  title: 'Auditoría Instagram Pro',
  desc: 'Checklist express para detectar qué está fallando en tu perfil y qué corregir primero.',
  value: "$17.990"
}];
export const TOP_TESTIMONIALS: Testimonial[] = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Córdoba',
  role: 'Dueña de Centro de Estética',
  quote: 'Organicé todo mi Instagram en una tarde. El tomo de stories me ahorra horas cada semana y empecé a recibir consultas reales.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  role: 'Cosmetóloga',
  quote: 'El Tomo 5 de cierre por DM fue un antes y un después. Antes respondía con el precio y perdía la consulta. Ahora cierro 4 de cada 5.'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  role: 'Estética Médica',
  quote: 'Mi perfil por fin refleja la calidad de mi trabajo. El Tomo 2 de imagen visual vale cada peso.'
}];
export const MORE_TESTIMONIALS: Testimonial[] = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  role: 'MegaPack + Acelerador',
  quote: 'El protocolo de DM me cambió la vida. Antes respondía con el precio y perdía el 80% de las consultas. Ahora cierro casi todas.'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  role: 'Dueña de Estética Médica',
  quote: 'Con el Tomo 2 de imagen visual mi perfil pasó de verse amateur a verse de clínica premium. Mismos tratamientos, diferente percepción.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  role: 'Cosmetóloga',
  quote: 'El sistema de stories del Tomo 3 me genera consultas todos los días. Antes publicaba y nada. Ahora publico y llegan mensajes.'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  role: 'Centro de Estética',
  quote: 'El Calendario Pro me ahorró 3 horas por semana. Planifico todo el mes en una mañana y el resto del mes solo ejecuto.'
}];
export const PAIN_POINTS: string[] = ['Domingo pensando qué subir porque la semana arranca y el perfil está vacío', 'Respondés "info precio" con el precio y la persona desaparece sin reservar', 'Tu feed se ve amateur aunque tu trabajo sea de primer nivel', 'Publicás de vez en cuando, sin consistencia, y el algoritmo te ignora', 'Tenés seguidores pero no se convierten en pacientes ni en turnos', 'Fin de semana agotada, el lunes volvés a empezar el mismo ciclo'];
export const ACCELERATOR_ROWS: {
  situation: string;
  without: string;
  with: string;
}[] = [{
  situation: 'Querés más consultas esta semana',
  without: 'Esperás que el algoritmo te ayude',
  with: 'Campaña activa en 48 horas'
}, {
  situation: 'La agenda tiene huecos',
  without: 'Publicás más y rezás',
  with: 'Anuncios dirigidos a 5 km de tu gabinete'
}, {
  situation: 'Querés llegar a pacientes nuevas',
  without: 'Solo llegás a tus seguidoras actuales',
  with: '10.000 personas nuevas por semana'
}, {
  situation: 'No sabés cuánto invertir',
  without: 'No tenés datos',
  with: 'Calculadora de presupuesto incluida'
}, {
  situation: 'Tenés miedo de perder plata',
  without: 'Sin sistema = sin control',
  with: 'Sistema de métricas y optimización paso a paso'
}];
export const ACCELERATOR_INCLUDES: string[] = ['Sistema de configuración de Meta Business Suite', 'El Público de 5 Kilómetros: segmentación local exacta', 'Los 3 tipos de anuncios que más convierten para estéticas', 'Embudo directo a WhatsApp con scripts de primera respuesta', 'Plan de 7 días para tu primera campaña activa', 'Biblioteca de 10 copys listos para anuncios', 'Calculadora de presupuesto y ROAS'];
export const COST_ROWS: {
  without: string;
  cost: string;
}[] = [{
  without: '3 hs pensando qué publicar × 4 semanas',
  cost: '12 horas de tu vida por mes'
}, {
  without: 'Responder "info precio" con solo el precio',
  cost: '70% de consultas perdidas'
}, {
  without: 'Perfil sin optimizar',
  cost: 'Visitas que no se convierten en nada'
}, {
  without: 'Sin sistema de stories',
  cost: 'Algoritmo que te ignora'
}, {
  without: 'Sin protocolo de cierre por DM',
  cost: 'Agenda con huecos evitables'
}, {
  without: 'El próximo domingo buscando qué subir',
  cost: 'El mismo ciclo, el próximo mes'
}];
export const FAQS: Faq[] = [{
  q: '¿Sirve aunque tenga pocos seguidores?',
  a: 'Sí. El sistema está diseñado exactamente para eso. El Tomo 1 optimiza el perfil para convertir visitas en consultas independientemente del número de seguidores. Con 500 seguidores bien orientados convertís más que con 5.000 sin sistema.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Acceso en menos de 5 minutos después del pago. Recibirás un email con el link de descarga. Los archivos son PDF de alta calidad, listos para leer en celular, tablet o computadora.'
}, {
  q: '¿Necesito saber de diseño o de marketing?',
  a: 'No. Todo está explicado paso a paso en lenguaje simple y directo. No necesitás conocimientos previos de marketing ni de diseño. Si sabés usar Instagram, podés implementar este sistema.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no estás satisfecha, escribís a soporte@creativodigital.shop y te devolvemos el 100% sin preguntas ni formularios complicados.'
}];